module.exports = __webpack_public_path__ + "static/media/sy.e2167449.svg";